var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containterClasses,staticStyle:{"font-size":"16px"}},[_c('div',{class:_vm.spinnerClass,style:(_vm.spinnerStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }